import { inject, Injectable } from '@angular/core';
import {
  collectionGroup,
  collectionSnapshots,
  Firestore,
} from '@angular/fire/firestore';
import { map, Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AnnotationsService {
  constructor() {}

  private firestore = inject(Firestore);

  getAnnotations(): Observable<{ [category: string]: { [id: string]: any } }> {
    return collectionSnapshots(
      collectionGroup(this.firestore, 'analysisAnnotations')
    ).pipe(
      take(1),
      map((snapshots) =>
        snapshots.reduce((acc, snap) => {
          const data = snap.data();
          const pathSegments = snap.ref.path.split('/');
          const index = pathSegments.indexOf('analysisAnnotations');
          const category = data['category'] || (index > 0 ? pathSegments[index - 1] : null);
          if (category) {
            if (!acc[category]) acc[category] = {};
            acc[category][snap.id] = { id: snap.id, category, ...data };
          }
          return acc;
        }, {} as { [category: string]: { [id: string]: any } })
      )
    );
  }
}
